import Auth from "./AuthHelper";
import { SESSION_HAS_EXPIRED } from "../configurations/MessageConstants";
import StorageHelper from "./StorageHelper";
import axios from "axios";
import { SIGNIN } from "../configurations/Urls";
import {
  CLAIM_IDS,
  LOG_OUT,
  LOGGING_OUT,
  REGISTERED_USER,
  SESSION_EXPIRED,
  SESSION_EXPIRED_MESSAGE,
  STAFF_LOGGED_IN_USER,
  STAFF_SESSION_EXPIRED,
  SUCCESSFUL_REGISTRATION,
  USER_POOL_GROUP,
  USERNAME,
} from "../configurations/Constants";

const SessionHelper = {
  cleanUpStorageKeys() {
    const username = StorageHelper.getItem(USERNAME);
    const staffUser = StorageHelper.getItem(STAFF_LOGGED_IN_USER);
    StorageHelper.removeItem(`${username}.idToken`);
    StorageHelper.removeItem(`${username}.accessToken`);
    StorageHelper.removeItem(`${username}.refreshToken`);
    StorageHelper.removeItem(USERNAME);
    StorageHelper.removeItem(REGISTERED_USER);
    StorageHelper.removeItem(SUCCESSFUL_REGISTRATION);
    StorageHelper.removeItem(CLAIM_IDS);
    StorageHelper.removeItem(USER_POOL_GROUP);
    StorageHelper.removeItem(`${staffUser}.idToken`);
    StorageHelper.removeItem(`${staffUser}.accessToken`);
    StorageHelper.removeItem(`${staffUser}.refreshToken`);
    StorageHelper.removeItem(STAFF_LOGGED_IN_USER);
  },

  isUserLoggedIn() {
    const token = Auth.getCurrentSession();
    if (!token) return;

    const stoken = token.split(".");
    const eData = JSON.parse(
      Buffer.from(stoken[1], "base64").toString("ascii")
    );
    const currentTime = parseInt(Number(new Date()) / 1000);
    if (eData.exp > currentTime) {
      return true;
    } else {
      StorageHelper.setItem(SESSION_EXPIRED, true);
      StorageHelper.setItem(SESSION_EXPIRED_MESSAGE, SESSION_HAS_EXPIRED);
      StorageHelper.setItem(LOGGING_OUT, LOG_OUT + Math.random());
      StorageHelper.removeItem(LOGGING_OUT);
      this.cleanUpStorageKeys();
      return false;
    }
  },

  isStaffLoggedIn() {
    const token = Auth.getCurrentStaffSession();
    if (!token) return;

    const stoken = token.split(".");
    const eData = JSON.parse(
      Buffer.from(stoken[1], "base64").toString("ascii")
    );
    const currentTime = parseInt(Number(new Date()) / 1000);
    if (eData.exp > currentTime) {
      return true;
    } else {
      StorageHelper.setItem(STAFF_SESSION_EXPIRED, true);
      StorageHelper.setItem(LOGGING_OUT, LOG_OUT + Math.random());
      StorageHelper.removeItem(LOGGING_OUT);
      this.cleanUpStorageKeys();
      return false;
    }
  },

  async handleRefreshToken() {
    const token = Auth.getCurrentSession();
    if (!token) return;

    const stoken = token.split(".");
    const eData = JSON.parse(
      Buffer.from(stoken[1], "base64").toString("ascii")
    );
    const currentTime = parseInt(Number(new Date()) / 1000);
    if (currentTime > eData.exp - 900) {
      try {
        const username = StorageHelper.getItem(USERNAME);
        const refresh_token = StorageHelper.getItem(`${username}.refreshToken`);
        const { data } = await axios.put(`${SIGNIN}/refresh`, {
          username,
          refresh_token,
        });
        StorageHelper.setItem(`${username}.idToken`, data.data.IdToken);
        StorageHelper.setItem(`${username}.accessToken`, data.data.AccessToken);
        return true;
      } catch (error) {
        StorageHelper.setItem(SESSION_EXPIRED, true);
        StorageHelper.setItem(SESSION_EXPIRED_MESSAGE, SESSION_HAS_EXPIRED);
        StorageHelper.setItem(LOGGING_OUT, LOG_OUT + Math.random());
        StorageHelper.removeItem(LOGGING_OUT);
        this.cleanUpStorageKeys();
        window.location.reload();
        return false;
      }
    } else {
      return true;
    }
  },

  async getHeaderWithToken() {
    const token = Auth.getCurrentSession();
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return headers;
  },

  async getHeaderWithTokenForMultipart() {
    const token = Auth.getCurrentSession();
    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: token,
    };
    return headers;
  },

  getHeaderWithStaffToken() {
    const token = Auth.getCurrentStaffSession();
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return headers;
  },

  isStaffMember() {
    return StorageHelper.isReqTokenPresent();
  },
};
export default SessionHelper;
